import { Rule } from '../../Rules'

const whyForkRules: Array<Rule> = [
  {
    details: 'The amount of XYO that was flowing back to the parent geotokens was not correct (too low)',
    reason:
      'The 75% to the current geotoken worked correctly, but the 16%, 4%, 1%, 0.25% were calculated from the remaining tokens instead of the initial minting deposit, making them too low and causing the majority of the tokens to be burned.',
    summary: 'A critical bug was located in the initial contract after the first XYOW NFT was minted',
  },
  {
    details: 'There is no other way to fix this.  Smart contracts are immutable in nature.',
    reason:
      'The XYO World smart contracts are intentionally written without upgradability or the ability for us to control them.  The only way to change the way it works is to make a new contract that clones the state of the previous contract with the new code.',
    summary: 'Why fix this by forking?',
  },
  {
    details:
      'A fork can always be done, but at a very high cost.  That is why we did this as fast as possible.  A fork also requires a consensus of the users of the contract to switch to the new contract.',
    reason:
      'When forking, the XYO tokens that are locked up in the previous contracts can not be moved to the new contracts. This means that for this fork, XYO has to contribute over 14M XYO tokens to the new contract to match the state.  Once several layers of the world have been minted, this will become prohibitive.',
    summary: 'What stops XYO from forking to change the rules in the future?',
  },
]

export default whyForkRules
